/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'


class StepWizard extends React.Component {

    renderSteps(steps) {
        return steps.map((step, i, arr) => {
            return (
                <React.Fragment key={i}>
                    <div className={this.getButtonClass(this.props.activeStep, i, arr)} onClick={() => {
                        if (this.props.clickable && (i !== 3 && i !== 2) && (this.props.activeStep !== 3 && this.props.activeStep !== 2)) {
                            this.props.stepClicked(i)
                        }
                    }} >
                        <div className="step-number">{i + 1}</div>
                        <div className="step-label" style={{color: this.props.activeStep < i ? "white" : ""}} onClick={(e) => e.stopPropagation()}>{step}</div>
                    </div>
                    {i < arr.length - 1 ?
                        <div className={this.getLineClass(this.props.activeStep, i + 1, arr)}></div>
                        :
                        ''
                    }
                </React.Fragment>
            )
        })
    }

    getButtonClass(step, i) {
        let cls = 'wiz-button ';
        if (i < step) {
            cls += "wiz-button-previous";
        } else if (i === step) {
            cls += "wiz-button-current";
        } else {
            cls += "wiz-button-next";
        }
        if (this.props.clickable && (i !== 3 && i !== 2) && (this.props.activeStep !== 3 && this.props.activeStep !== 2)) {
            cls += " clickable"
        }
        return cls;
    }

    getLineClass(step, i) {
        let cls = 'wiz-line ';
        if (i <= step) {
            cls += "wiz-line-previous";
        } else {
            cls += "wiz-line-next";
        }
        return cls;
    }

    render() {
        return (
            <div className="wiz-layout">
                {this.renderSteps(this.props.steps)}
                <div className="step-label step-label-mobile">{this.props.steps[this.props.activeStep]}</div>
            </div>
        )
    }
}


export default StepWizard